(function() {
    module.exports = {
        init: init
    }

//    init();
    var chapter_slides;
    var chapter;
    var testimonies;
    var people;
    var vidId;
    var expert;
    var current_audio;


    function init(data, chap, lang) {
        console.log("INIT")
        $("#ambient-background").animate({
            volume:0,
        },1000)
        expert = "";
        vidId = 0;
        current_audio = "";
        testimonies = data.testimonies;
        people = data.people
        _lang = lang;
        chapter = chap;
        chapter_slides = data;
    /*    $("#next-chapter-container").click(function() {
            window.location.replace('#'+$(this).attr("data-chapter"));
            location.reload();
        });
*/


        $(".popup-close").click(function() {
            $(this).parent().removeClass("popedUp").fadeOut();
        });
        $("#slides-container").fadeIn(function() {
            $("#back-to-top").click(function() {
                $('#main-view-container').scrollTop(0);
            });
        });
        $('.audio-player').each(function() {
            prep_audio($(this));
        });

        add_subtitles('videoSlide', '#video-slide-subtitles');

        $(".waypoint").each(function() {
            $(this).waypoint({
                handler: function(direction) {
                    load_slide(this, direction);
                },
                offset: '100%',
                continuous: false,
                context: '#main-view-container'
            });

        });

//        $(".current").removeClass("current");
        $("#background_1").addClass("current")

        $(".background.current").css("display", "block");

        load_background($("#titlePage001"));
        switch_backgrounds();

     /*   setTimeout(function() {
            vid = load_background($("#titlePage001").next());
        }, 2500);
*/
        $(".expert-btn").click(function() {
            person = get_person_info($(this).attr("data-person"));
            $("#expert-name").text(person.name);
            $("#expert-title a").text(person.subtitle);
            $("#expert-workplace").text(person.subtitle2);
            $("#expert-image").css("background-image", "url('media/TCphotos/"+person.portrait+"')");
            testimony = get_testimony_info($(this).attr("data-testimony"));
            $("#expert-section-title").text(testimony.title);
            $(this).parent().addClass("current").children().fadeOut();
            if($(this).prev().prev().hasClass("audio-player")==true) {
                $(this).prev().prev().animate({
                    volume:0
                },1000, function() {
                    el = document.getElementById($(this).attr("id"));
                    el.pause();
                    current_expert = $(this).attr("id");
                });
            }
            timeIn = $(this).attr("data-in");
            timeOut = $(this).attr("data-out");
//	    setTimeout(function() {
            create_transcript($(this).next().attr('id'), timeIn, timeOut);
//	    },500)
            expert = $(this).next().attr('id');
            setTimeout(function() {
//                $("#transcript-container").niceScroll();
            },1000);
        });

        $("#expert-insert-close").click(function() {
            $(".slide.current").children().fadeIn();
            //	video.pause();
            audio = document.getElementById(expert);
            audio.pause();
            $("#expert-insert").fadeOut();
            console.log(current_expert)
            if(current_expert!="") {
                el = document.getElementById(current_expert);
                el.play();
                $("#"+current_expert).animate({volume:1},1000);
            }
        });

        $("#expert-insert-read").click(function() {
            audio = document.getElementById(expert);
            audio.pause();
            $(".expert-controls.active").removeClass("active");
            $(this).addClass("active");
        });

        $("#expert-insert-listen").click(function() {
            audio = document.getElementById(expert);
            audio.play();
            $(".expert-controls.active").removeClass("active");
            $(this).addClass("active");
        });

        $(".subtitle-container").click(function() {
           /* $(this).fadeOut();
            $(this).prev().animate({
                opacity: 1,
            },1000)*/
           $(".pause-img").remove();
           $(this).find('a').text('')
            if($(this).attr('id')!= 'video-slide-subtitles') {
                audioId = $(this).attr('data-audio')
                current_audio = audioId;
                v = document.getElementById(audioId);
                if(v.playing) {
                    $('#main-view-container').append("<img class='pause-img enlarge' src='media/icons/pause-btn-white.png'/>")
                    v.pause();
                } else {
                    v.play();
                }
            } else {
                v = document.getElementById("videoSlide");
                if(v.playing) {
                    $('#main-view-container').append("<img class='pause-img enlarge' src='media/icons/pause-btn-white.png'/>")
                    v.pause();
                } else {
                    v.play();
                }
            }
        })
    }

    function get_testimony_info(uid) {
        data = {};
        for (t=0; t < testimonies.length; t++) {
            testimony = testimonies[t];
            if(testimony.uid == uid) {
                data["filename"] = testimony.filename;
                data["vtt"] = testimony.vtt;
                data["pid"] = testimony.pid;
                data["title"] = testimony.title;
                data["date"] = testimony.date;
            }
        }
        return data;
    }

    function get_person_info(pid) {
        data = {};
        for (p=0; p < people.length; p++) {
            person = people[p];
            if(person.pid == pid) {
                data["name"] = person.name;
                data["subtitle"] = person.subtitle;
                data["subtitle2"] = person.subtitle2;
                data["portrait"] = person.portrait;
                data["location"] = person.location;
                data["quote"] = person.quote;
            }
        }
        return data;
    }

    var transcript_scroll = 0;

    function create_transcript(audio, timeIn, timeOut) {
        console.log("audio = " + audio)
        $("#transcript-container").html("").scrollTop(0);
        el = document.getElementById(audio);
        console.log(el)
        if (timeIn == "") {
            timeIn = 0;
        }
        if (timeOut == "") {
            timeOut = el.duration;
        }
        el.currentTime = timeIn;
        track = el.textTracks[0];
        track.mode = "showing";
        console.log(track)
        setTimeout(function () {
            cues = track.cues;
            console.log(cues.length)
            for (i = 0; i < track.cues.length; i++) {
                track.cues[i].id = i;
                if (track.cues[i].startTime >= timeIn && track.cues[i].endTime <= timeOut) {
                    console.log(track.cues[i].text)
                    $("#transcript-container").append("<p id='sub-" + track.cues[i].id + "' class='transcript-subtitle unplayed' data-in='" + track.cues[i].startTime + "'>" + track.cues[i].text + "</p>");
                }
            }
        }, 1000)

        $(".transcript-subtitle").click(function () {
            el.currentTime = $(this).attr("data-in");
        });
        track.oncuechange = function () {
            if (el.currentTime >= timeOut) {
                el.pause();
            }
            subtitle = this.activeCues[0].id;
            console.log(subtitle)
            $(".activeSubtitle").removeClass("activeSubtitle");
            $("#sub-" + subtitle).addClass("activeSubtitle played").removeClass("unplayed");
            ;
            sub_pos = $("#sub-" + subtitle).offset().top - $("#transcript-container").offset().top;
            target = $("#transcript-container").height() - ($("#transcript-container").height() / 2.5);
            console.log('sub= ' + sub_pos);
            console.log('target= ' + target);
            if (sub_pos > target) {
                transcript_scroll = transcript_scroll + (sub_pos - target) + $("#sub-" + subtitle).height();
                console.log(transcript_scroll);
                $("#transcript-container").animate({scrollTop: transcript_scroll + 'px'}, 1000)
            }
        };
        $("#expert-insert").fadeIn();
        el.play();

    }

    var current_expert = '';

    function switch_backgrounds() {
        console.log("switch")
        /*	if($(".background:not(.current)").hasClass("vidToPlay")) {
                vid = document.getElementById($(".background:not(.current)").find("video").attr("id"));
                vid.play();
                $(".background:not(.current)").removeClass("vidToPlay");
                };*/
        if($("#video-slide-container").hasClass("active") == true ) {
            $("#video-slide-container").fadeOut(function(){ v = document.getElementById("videoSlide").pause()}).removeClass("active");
        }
        if ($('.background.current').attr('id') == "background_2") {
            $("#background_2").fadeOut(1500);
        } else {
            $("#background_2").fadeIn(1500);
        };
        $('.background').toggleClass('current');
    };

    //    $(".background.current").fadeIn(3000);
    //  load_slide(document.getElementById("first-title"), 'down')

    function load_audio(media, vtt) {
        $("#audio-container").html("<video id='audio-player' playsinline><source src='media/testimonies/"+media+".mp3' type='audio/mp3'></source><track src='media/testimonies/"+vtt+"."+_lang+".vtt' kind='subtitles' srclang='en' label='English'></track></video>");
    }

    function add_subtitles(video, container) {
        audio = document.getElementById(video);
        track = audio.textTracks[0];
        track.mode = "hidden";
//	add_transcript(track);
        track.oncuechange = function() {
            subtitle = this.activeCues[0].text;
            $(container).text(subtitle);
            //                      center_subtitle();
        };
    }

    function set_end(video, end) {
        audio = document.getElementById(video);
        $("#"+video).on("timeupdate", function() {
            if(this.currentTime > end){
                $(this).animate({volume:0},500, function() {
                    this.pause();
                });
                $(this).siblings().not('.audio-player').fadeOut();
                $(this).prev().fadeOut(2000, function() {
                    $("#ambient-background").animate({volume:1}, 1000);
                    $(this).next().next().next().fadeIn();
                    $(".refresh-btn").click(function() {
                        $(this).fadeOut();

                        console.log($(this).prev().attr("data-in"))
                        if($(this).prev().prev().attr("data-in")!="") {
                            $(this).prev().prev().currentTime = $(this).prev().prev().attr("data-in");
                        } else {
                            $(this).prev().prev().currentTime = 0;
                        }
                        el = document.getElementById($(this).prev().prev().attr('id'));
                        if($(this).prev().prev().attr("data-in")!="") {
                            el.currentTime = $(this).prev().prev().attr("data-in");
                        } else {
                            el.currentTime = 0;
                        }
//			$(this).siblings().not('.audio-player').fadeIn(function() {
                        el.play();
                        $(this).prev().prev().animate({volume:1});
                        $(this).siblings().not('.audio-player').fadeIn();
//			});
                        //		$(this).prev().prev().prev().fadeIn();
                    });

                });
            }
        });
    }

    function prep_audio(obj) {
        audioId = obj.attr('id');
        cont = "#"+obj.prev().find('.subtitle-container').attr('id')
        add_subtitles(audioId, cont);

        $("#"+audioId).on("timeupdate", function() {
            if ($(this).attr("data-out")!="") {
                end = parseInt($(this).attr("data-out"));
            } else {
                end = this.duration;
            };
            if ($(this).attr("data-in")!="") {
                start = parseInt($(this).attr("data-in"));
            } else {
                start = 0;
            };
            time = this.currentTime - start;
            duration = end - start;
            value = (time/duration)*100;
            $(this).prev().find(".timeline-bar").css("width",String(value)+"%");
        });

        $(".timeline").unbind().click(function(e) {
            if ($(this).parent().next().attr("data-out")!="") {
                end = parseInt($(this).parent().next().attr("data-out"));
            } else {
                end = $(this).parent().next()[0].duration;
            };
            if ($(this).parent().next().attr("data-in")!="") {
                start = parseInt($(this).parent().next().attr("data-in"));
            } else {
                start = 0;
            };
            duration = end - start;
            pc = ((e.pageX - $(this).offset().left)/$(this).width())*100;
            $(this).parent().next()[0].currentTime = ((duration/100)*pc) + start;
        });

        $(".play-btn").unbind().click(function() {
            if($(this).hasClass('pause') ==true) {
                $(this).parent().next()[0].pause();
                $(this).removeClass('pause').addClass('play').css("background-image", "url('media/icons/play-btn.svg')");
            } else {
                $(this).removeClass('play').addClass('pause').css("background-image", "url('media/icons/pause-btn.svg')");
                $(this).parent().next()[0].play()
            }
        });

        if($('#'+audioId).attr('data-out')!='') {
            set_end(audioId, $('#'+audioId).attr('data-out'));
        } else {
            $('#'+audioId).on("ended", function() {
                $(this).siblings().fadeOut();
                $(this).prev().fadeOut(2000, function() {
                    $("#ambient-background").animate({volume:1}, 1000);
                    $(this).next().next().next().fadeIn();
                    $(".refresh-btn").click(function() {
                        $(this).fadeOut();
                        $(this).siblings().fadeIn(function() {
                            console.log($(this).prev().attr("data-in"))
                            if($(this).prev().attr("data-in")!="") {
                                $(this).prev().currentTime = $(this).prev().attr("data-in");
                            } else {
                                $(this).prev().currentTime = 0;
                            }
                            el = document.getElementById($(this).prev().attr('id'));
                            if($(this).prev().attr("data-in")!="") {
                                el.currentTime = $(this).prev().attr("data-in");
                            } else {
                                el.currentTime = 0;
                            }
                            el.play();
                        });
//			    $(this).prev().prev().fadeIn();
//			$(this).prev().prev().prev().fadeIn();
                    });
                });
            });
        }
        if($('#'+audioId).attr('data-in')!='') {
            document.getElementById(audioId).currentTime = $('#'+audioId).attr('data-in');
        }
    }


    /*    $('.audio-player').each(function() {
        prep_audio($(this));
        });
      */

    var media_root = 'media/footage/';
    var waypoints = []
 //   var expert = ""

/*    $("#expert-insert-close").click(function() {
        $(".slide.current").children().fadeIn();
        //	video.pause();
        audio = document.getElementById(expert);
        audio.pause();
        $("#expert-insert").fadeOut();
        console.log(current_expert)
        if(current_expert!="") {
            el = document.getElementById(current_expert);
            el.play();
            $("#"+current_expert).animate({volume:1},1000);
        }
    });

    $("#expert-insert-read").click(function() {
        audio = document.getElementById(expert);
        audio.pause();
        $(".expert-controls.active").removeClass("active");
        $(this).addClass("active");
    });

    $("#expert-insert-listen").click(function() {
        audio = document.getElementById(expert);
        audio.play();
        $(".expert-controls.active").removeClass("active");
        $(this).addClass("active");
    });*/

    // vidId = 0;
    //  load_background($("#titlePage"));
    // switch_backgrounds();

    function load_background(slide) {
        type = slide.attr('data-background-type');
        media = slide.attr('data-background-media');
        timeIn = slide.attr('data-in');
        timeOut = slide.attr('data-out');
        console.log(type, media)
        switch(type) {
            case('videoSlide'):
                id= 'videoSlide';
           /*     	    id = 'vid_'+String(vidId);
                        $(".background:not(.current)").html("<video id='"+id+"' class='editorial-vid audio-player' data-in='"+timeIn+"' data-out='"+timeOut+"'><source src='/media/footage/"+media+".mp4' type='video/mp4'></source><track src='../media/footage/"+media+".en.vtt' kind='subtitles' srclang='en' label='English'></track></video>").addClass("vidToPlay");
                        sub_cont = '#'+slide.find('.subtitle-container').attr('id');
                //	    add_subtitles(id, '#'+slide.find('.subtitle-container').attr('id'));
                        prep_audio($("#"+id));
                        add_subtitles(id, sub_cont);
                //	    document.getElementById(id).play();
                        current_audio = id; */
                vidId = vidId + 1;
                return id;
                break;
            case ('video'):
                id = 'vid_'+String(vidId);
                $(".background:not(.current)").html("<video id='"+id+"' class='editorial-vid' muted loop playsinline><source src='media/footage/"+media+".mp4' type='video/mp4'></source></video>");
                document.getElementById(id).play();
                vidId = vidId + 1;
                break;
            case ('image'):
                $(".background:not(.current)").html("").css("background-image","url('media/TCphotos/"+media+".jpg')");
                break;
            case ('map'):
                $(".background:not(.current)").css("background-image","none").html("<div id='streetViewContainer'></div>");
                googleStreetView(media, 'streetViewContainer');
                break;
            case ('text'):
                $(".background:not(.current)").css("background-color","black").css("background-image", "none").html("");
                break;
        }
    }

  //  var current_audio = '';

    function load_slide(obj, direction) {
        if(direction == 'down') {
            if($("#"+obj.element.id).parent().attr('data-background-type')=='videoSlide') {
                v = document.getElementById("videoSlide");
                v.play();
//		current_audio = 'videoSlide';
                $("#video-slide-container").fadeIn(2000).addClass("active");
                vid = load_background($("#"+obj.element.id).parent().next());

            } else if($("#"+obj.element.id).parent().attr('data-background-type')!='') {
//		vid = load_background($("#"+obj.element.id).parent())
                //		switch_backgrounds();
                switch_backgrounds();
                setTimeout(function() {
                    vid = load_background($("#"+obj.element.id).parent().next())
                },2500);
            }
        } else if (direction == 'up') {
            console.log(vid)
            if($("#"+obj.element.id).parent().attr('data-background-type')=='videoSlide') {
                v = document.getElementById('videoSlide').pause();
//		$("#video-slide-container").fadeIn(2000);
                $("#ambient-background").animate({volume:1}, 1000);
            }
            if($("#"+obj.element.id).parent().prev().attr('data-background-type')!=undefined) {
                if($("#"+obj.element.id).parent().prev().attr("data-background-type") == 'videoSlide') {
                    v = document.getElementById("videoSlide");
                    v.play();
                    $("#video-slide-container").fadeIn(2000).addClass("active");
                } else if ($("#"+obj.element.id).parent().prev().prev().attr("id") == 'titlePage001') {
                    load_background($("#"+obj.element.id).parent().prev().prev())
                    switch_backgrounds();
                } else {
                    load_background($("#"+obj.element.id).parent().prev())
                    switch_backgrounds();
                }
            }
        }

        if($("#"+obj.element.id).next().hasClass('audio-player')==true) {
            if(direction == 'down') {
                $("#ambient-background, .background-audio").animate({volume:0}, 1000);
                document.getElementById($("#"+obj.element.id).next().attr('id')).play();
                current_audio = $("#"+obj.element.id).next().attr('id');

            } else if (direction == 'up') {
                document.getElementById($("#"+obj.element.id).next().attr('id')).pause();
                current_audio = ''
                $("#ambient-background").animate({volume:1}, 1000);
            }
        }

        if($("#"+obj.element.id).parent().hasClass("text")==true) {
            if($("#"+obj.element.id).parent().prev().find('.audio-player').attr('id')!=undefined) {
                if(direction == 'down') {
                    document.getElementById($("#"+obj.element.id).parent().prev().find('.audio-player').attr('id')).pause();
                    current_audio = '';
                    $("#ambient-background").animate({volume:1}, 1000);

                } else if (direction == 'up') {
                    document.getElementById($("#"+obj.element.id).parent().prev().find('.audio-player').attr('id')).play();
                    current_audio = $("#"+obj.element.id).parent().prev().find('.audio-player').attr('id');
                    $("#ambient-background").animate({volume:0}, 1000);
                }
            } else if(current_audio!='') {
                if(direction == 'down') {
                    document.getElementById(current_audio).pause();
                    current_audio = '';
                    $("#ambient-background").animate({volume:1}, 1000);
                } else if (direction == 'up') {
                    document.getElementById(current_audio).play();
                    $("#ambient-background, .background-audio").animate({volume:0}, 1000);
                }
            }
        }
    }

})();